import { render, staticRenderFns } from "./page-case-detail.vue?vue&type=template&id=7f1b35b6&"
import script from "./page-case-detail.vue?vue&type=script&lang=js&"
export * from "./page-case-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports